import { session } from 'feature/widget/SessionStore'
import { observer } from 'mobx-react-lite'
import { BoutiqueQrModal } from 'page/catalog/BoutiqueQrModal/BoutiqueQrModal'
import { BuyModal } from 'page/catalog/BuyModal/BuyModal'
import { ComboCartModal } from 'page/catalog/ComboCart'
import { EmployeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModal'
import { employeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { FiltersDrawer } from 'page/catalog/FiltersDrawer/FiltersDrawer'
import { FiltersModal } from 'page/catalog/FiltersModal/FiltersModal'
import { ItemPreviewModal } from 'page/catalog/ItemPreview/ItemPreviewModal'
import { LogoutModal } from 'page/catalog/LogoutModal/LogoutModal'
import { StandExitModal } from 'page/catalog/StandExitModal/StandExitModal'
import { boutiqueQrModal } from 'page/catalog/store/BoutiqueQrModalStore'
import { buyModal } from 'page/catalog/store/BuyModalStore'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { standExit } from 'page/catalog/store/StandExitModalStore'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import { UserModal } from 'page/catalog/UserModal/UserModal'

export const Modals = observer(() => {
  const { stand, drawer } = useDemo()

  return <>
    {drawer ? stand ? <FiltersModal /> : <FiltersDrawer /> : null}
    {comboCartStore.open && <ComboCartModal />}
    {boutiqueQrModal.present && <BoutiqueQrModal />}
    {employeeModal.present && <EmployeeModal />}
    {userModal.present && <UserModal />}
    {itemPreview.present && <ItemPreviewModal />}
    {buyModal.present && <BuyModal />}
    {standExit.present && <StandExitModal />}
    {!session.active && <LogoutModal />}
  </>
})
